"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3215],{

/***/ 81649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ AvatarSize; },
/* harmony export */   "rH": function() { return /* binding */ AVATAR_SIZE_METRICS; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92145);
/* harmony import */ var _components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34368);
/* harmony import */ var _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42079);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39819);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97033);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: ",
        "px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: -",
        "px;\n    left: -",
        "px;\n    width: ",
        "px;\n    height: ",
        "px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var AVATAR_SIZE_METRICS = [
    {
        size: 16,
        radius: 5
    },
    {
        size: 24,
        radius: 8
    },
    {
        size: 32,
        radius: 12
    },
    {
        size: 44,
        radius: 16
    },
    {
        size: 50,
        radius: 10
    },
    {
        size: 64,
        radius: 24
    },
    {
        size: 100,
        radius: 36
    },
    {
        size: 116,
        radius: 15
    },
    {
        size: 189,
        radius: 20
    }, 
];
var AvatarSize;
(function(AvatarSize) {
    AvatarSize[AvatarSize["xsmall"] = 0] = "xsmall";
    AvatarSize[AvatarSize["small"] = 1] = "small";
    AvatarSize[AvatarSize["medium"] = 2] = "medium";
    AvatarSize[AvatarSize["large"] = 3] = "large";
    AvatarSize[AvatarSize["largeSquare"] = 4] = "largeSquare";
    AvatarSize[AvatarSize["xlarge"] = 5] = "xlarge";
    AvatarSize[AvatarSize["xxlarge"] = 6] = "xxlarge";
    AvatarSize[AvatarSize["xxxlarge"] = 7] = "xxxlarge";
    AvatarSize[AvatarSize["xxxxlarge"] = 8] = "xxxxlarge";
})(AvatarSize || (AvatarSize = {}));
var avatarWrapCSS = function(param) {
    var size = param.size;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), size, size);
};
var avatarCSS = function(param) {
    var size = param.size, radius = param.radius;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), size, size, radius);
};
var avatarDecorationCSS = function(param) {
    var size = param.size;
    var ratio = size > 32 ? 2 : 1.75;
    var width = size * ratio;
    var axis = (width - size) / 2;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject2(), axis, axis, width, width);
};
var Avatar = function(param) {
    var className = param.className, id = param.id, _size = param.size, size = _size === void 0 ? 2 : _size, picture = param.picture, overrideDecoration = param.decoration, _hideDecoration = param.hideDecoration, hideDecoration = _hideDecoration === void 0 ? false : _hideDecoration, onClick = param.onClick;
    var avatarMetrics = AVATAR_SIZE_METRICS[size];
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_4__/* .useUserMarketItemInventory */ .wg)(id), data = ref.data, getDecoration = ref.getDecoration;
    var decoration = !hideDecoration ? overrideDecoration !== null && overrideDecoration !== void 0 ? overrideDecoration : getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_3__/* .MarketItemType.userPicture */ .q9.userPicture) : undefined;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        css: avatarWrapCSS(avatarMetrics),
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: avatarCSS(avatarMetrics),
                children: picture && picture.key ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                    image: picture,
                    h: _components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* .EFinderImageSizes.chatbot */ .ny.chatbot,
                    radius: avatarMetrics.radius
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    icon: _public_icons_profile_32_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                    d: avatarMetrics.size
                })
            }),
            decoration && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                css: avatarDecorationCSS(avatarMetrics),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_common_EFinderImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
                    image: size >= 3 ? decoration.object.pageProfile : decoration.object.pageComment
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Avatar);


/***/ }),

/***/ 34270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39819);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30259);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  padding-bottom: ",
        "px;\n  color: ",
        ";\n  text-align: center;\n  line-height: 135%;\n  font-size: ",
        "px;\n\n  i {\n    display: inline-flex;\n    margin-bottom: ",
        "px;\n  }\n  svg {\n    margin-bottom: ",
        "px;\n  }\n  i svg {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var emptyCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxxlarge */ .Ki.xxxlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, theme.var.gray400, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.large */ .Ki.large);
};
var Empty = function(param) {
    var className = param.className, empty = param.empty, query = param.query, _hideIcon = param.hideIcon, hideIcon = _hideIcon === void 0 ? false : _hideIcon, children = param.children;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.u)();
    var isCheming = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalContext */ .bN)().isCheming;
    var isQueryDataEmpty = query ? query.isFetched && query.count === 0 : false;
    if (isQueryDataEmpty || empty) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            css: emptyCSS,
            className: className,
            "data-test": _constants__WEBPACK_IMPORTED_MODULE_3__/* .DATA_TEST.EMPTY */ .AY.EMPTY,
            children: [
                hideIcon ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                    children: !isCheming ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Chatie */ .Tq,
                        size: chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Sizes.xlarge */ .u8.xlarge,
                        color: theme.var.gray300
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "33",
                        height: "39",
                        viewBox: "0 0 33 39",
                        fill: "none",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M6.28125 29.8817C7.244 28.9849 8.75295 28.1772 11.1333 28.1772C13.1735 28.1772 14.8738 29.0656 16.523 29.9264C18.1084 30.7531 19.5876 31.1527 21.7597 31.1527C24.4566 31.1527 26.2929 30.3939 26.7179 30.0433C26.7179 30.0433 19.2943 36.9037 16.9969 37.1992C14.6995 37.4946 7.28013 31.7924 6.28337 29.8839L6.28125 29.8817Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M13.9451 6.39503H18.9161L21.0478 3.24321C21.7087 2.33783 21.577 1.02015 20.6631 0.374054C20.3294 0.138145 19.932 0 19.5048 0H13.5222C13.0121 0 12.5424 0.197654 12.1705 0.527075C11.4118 1.20505 11.3459 2.37609 11.924 3.21558L13.9451 6.39503Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M30.688 14.1371C29.315 12.1627 26.922 10.7749 24.446 10.5198C23.0582 10.3774 21.7108 10.5942 20.4824 11.1255V9.43166H21.4685C21.9722 9.43166 22.3802 9.0236 22.3802 8.51991C22.3802 8.01621 21.9722 7.60815 21.4685 7.60815H11.5307C11.027 7.60815 10.6189 8.01621 10.6189 8.51991C10.6189 9.0236 11.027 9.43166 11.5307 9.43166H12.5891V11.1553C11.3415 10.6006 9.9686 10.3753 8.55316 10.5198C6.07508 10.7749 3.68202 12.1606 2.30908 14.1371C-0.30501 17.8967 -0.0733534 23.006 2.92117 27.4818C6.29611 32.3977 10.1832 35.6961 15.15 37.8597C15.6006 38.0552 16.0469 38.1594 16.5187 38.1679C16.9523 38.1594 17.4007 38.0552 17.8513 37.8597C22.818 35.6961 26.703 32.3977 30.0865 27.4733C33.0725 23.0081 33.3042 17.8967 30.6901 14.1392L30.688 14.1371ZM14.4126 9.43166H18.661V12.2222C18.4803 12.3667 18.2997 12.5155 18.1275 12.677C17.5261 13.2466 17.0564 13.4782 16.506 13.4782H16.4932C15.9428 13.4782 15.4731 13.2466 14.8716 12.677C14.7228 12.5367 14.5677 12.4113 14.4126 12.2859V9.43166ZM28.5754 26.449C25.4024 31.0715 21.7618 34.1659 17.1223 36.1871C16.8949 36.287 16.6717 36.3401 16.5187 36.3444C16.3274 36.3401 16.1043 36.2848 15.8769 36.1871C11.2353 34.1659 7.59678 31.0694 4.43012 26.4575C1.86915 22.6298 1.63112 18.3069 3.80741 15.1764C4.88705 13.6249 6.77643 12.5346 8.74018 12.3327C8.94846 12.3114 9.17374 12.2987 9.41177 12.2987C10.6317 12.2987 12.1874 12.6472 13.6198 14.0032C14.2107 14.5621 15.15 15.3039 16.4932 15.3039H16.506C17.8491 15.3039 18.7906 14.5621 19.3793 14.0032C21.0902 12.3837 22.9753 12.2009 24.259 12.3348C26.2227 12.5367 28.1142 13.627 29.1918 15.1785C31.368 18.3069 31.1279 22.6298 28.5754 26.449Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M21.2074 21.0448C21.8788 21.0448 22.423 20.4025 22.423 19.6102C22.423 18.8179 21.8788 18.1757 21.2074 18.1757C20.536 18.1757 19.9917 18.8179 19.9917 19.6102C19.9917 20.4025 20.536 21.0448 21.2074 21.0448Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M11.7921 21.0448C12.4635 21.0448 13.0077 20.4025 13.0077 19.6102C13.0077 18.8179 12.4635 18.1757 11.7921 18.1757C11.1207 18.1757 10.5764 18.8179 10.5764 19.6102C10.5764 20.4025 11.1207 21.0448 11.7921 21.0448Z",
                                fill: "#D8D8D8"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("path", {
                                d: "M19.2134 23.2167C17.7024 24.6067 15.2456 24.6088 13.7345 23.2167C13.3647 22.8767 12.7887 22.9 12.4466 23.2699C12.1044 23.6397 12.1299 24.2177 12.4997 24.5578C13.5942 25.5673 15.0352 26.071 16.474 26.071C17.9128 26.071 19.3537 25.5673 20.4482 24.5578C20.818 24.2177 20.8435 23.6397 20.5014 23.2699C20.1592 22.9 19.5832 22.8767 19.2134 23.2167Z",
                                fill: "#D8D8D8"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    children: children
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Empty);


/***/ }),

/***/ 39753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gt": function() { return /* binding */ PaginationIterator; }
/* harmony export */ });
/* unused harmony export Pagination */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74001);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47304);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_sum__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8801);
/* harmony import */ var _layout_List__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43481);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30208);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: auto;\n\n  li {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  > * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Pagination = function(param) {
    var query = param.query, children = param.children;
    var ref = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .YD)(), ref1 = ref.ref, inView = ref.inView;
    var hasNextPage = query.hasNextPage, isFetchingNextPage = query.isFetchingNextPage, fetchNextPage = query.fetchNextPage;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isFetchingNextPage && hasNextPage && inView) {
            fetchNextPage();
        }
    }, [
        hasNextPage,
        isFetchingNextPage,
        inView,
        fetchNextPage
    ]);
    return hasNextPage ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        ref: ref1,
        onClick: isFetchingNextPage ? undefined : function() {
            return fetchNextPage();
        },
        children: children
    }) : null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (Pagination);
var horizontalCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xsmall */ .Ki.xsmall);
var PaginationIterator = function(param) {
    var className = param.className, name = param.name, query = param.query, ad = param.ad, inFeedAd = param.inFeedAd, _inFeedAdInterval = param.inFeedAdInterval, inFeedAdInterval = _inFeedAdInterval === void 0 ? 4 : _inFeedAdInterval, _inFeedAdStart = param.inFeedAdStart, inFeedAdStart = _inFeedAdStart === void 0 ? 2 : _inFeedAdStart, border = param.border, margin = param.margin, _identifier = param.identifier, identifier = _identifier === void 0 ? "id" : _identifier, _direction = param.direction, direction = _direction === void 0 ? "vertical" : _direction, _next = param.next, next = _next === void 0 ? true : _next, prevComponent = param.prevComponent, _$css = param.css, children = param.children;
    var ref;
    var isError = query.isError, data = query.data;
    if (isError) {
        return null;
    }
    var ref1;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_layout_List__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: className,
                css: _$css ? _$css : direction === "horizontal" ? horizontalCSS : undefined,
                border: border,
                margin: margin,
                children: [
                    ad && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                        children: ad
                    }),
                    prevComponent && prevComponent,
                    (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.map(function(page, i) {
                        var ref;
                        var _lastEvaluatedKey;
                        var key = "page" in page ? page.page : (_lastEvaluatedKey = page.lastEvaluatedKey) !== null && _lastEvaluatedKey !== void 0 ? _lastEvaluatedKey : page.next;
                        var ref1;
                        var prevItemLength = lodash_sum__WEBPACK_IMPORTED_MODULE_2___default()(data === null || data === void 0 ? void 0 : data.pages.map(function(p) {
                            var ref;
                            return (ref1 = (ref = p.items) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0;
                        }).slice(0, i));
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: (ref = page.items) === null || ref === void 0 ? void 0 : ref.map(function(item, j) {
                                var rendered = children(item, prevItemLength + j, i);
                                var globalIndex = prevItemLength + j;
                                var showInFeedAd = inFeedAd && inFeedAdInterval > 0 && globalIndex + 1 >= inFeedAdStart && (globalIndex + 1 - inFeedAdStart) % inFeedAdInterval === 0;
                                if (rendered) {
                                    var _identifier;
                                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                                                children: rendered
                                            }),
                                            showInFeedAd && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                                                children: inFeedAd
                                            })
                                        ]
                                    }, "".concat(name, "-").concat(key, "-").concat((_identifier = item[identifier]) !== null && _identifier !== void 0 ? _identifier : (0,uuid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)()));
                                }
                                return null;
                            })
                        }, "".concat(name, "-").concat(key));
                    })) !== null && ref1 !== void 0 ? ref1 : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        push: true
                    }),
                    direction === "horizontal" && next && query.hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Pagination, {
                            query: query,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                size: 6
                            })
                        })
                    })
                ]
            }),
            direction === "vertical" && next && query.hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Pagination, {
                query: query,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {})
            })
        ]
    });
};


/***/ }),

/***/ 43481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      > li {\n        border-bottom: 1px solid ",
        ";\n      }\n\n      > li.no-border {\n        border-bottom: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      > li + li {\n        margin-top: ",
        "px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var listCSS = function(hasBorder, hasMargin) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), hasBorder && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.border.lightest), hasMargin && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small));
    };
};
var List = function(param) {
    var className = param.className, _border = param.border, border = _border === void 0 ? false : _border, _margin = param.margin, margin = _margin === void 0 ? false : _margin, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
        css: listCSS(border, margin),
        className: className,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (List);


/***/ }),

/***/ 1028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DE": function() { return /* binding */ RRStoryCard; },
  "di": function() { return /* binding */ RSStoryCard; },
  "FW": function() { return /* binding */ SRStoryCard; },
  "Ey": function() { return /* binding */ StoryCard; },
  "nH": function() { return /* binding */ StoryTag; },
  "ZP": function() { return /* binding */ stories_Story; },
  "V4": function() { return /* binding */ storyActionCSS; },
  "rr": function() { return /* binding */ storyWrapCSS; }
});

// UNUSED EXPORTS: coverImageCSS

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./hooks/useFirebase.ts + 1 modules
var useFirebase = __webpack_require__(37666);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
;// CONCATENATED MODULE: ./public/icons/ic_lock.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcLock = function SvgIcLock(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M10.333 13.333H7.667A2.667 2.667 0 0 0 5 16v9.333A2.667 2.667 0 0 0 7.667 28h16a2.667 2.667 0 0 0 2.666-2.667V16a2.667 2.667 0 0 0-2.666-2.667H21m-10.667 0v-4a5.333 5.333 0 1 1 10.667 0v4m-10.667 0H21m-5.333 5.334v4"
  })));
};
/* harmony default export */ var ic_lock = (SvgIcLock);
;// CONCATENATED MODULE: ./public/images/partnership/honor/story_badge.png
/* harmony default export */ var story_badge = ({"src":"https://mn.chatie.me/assets/1e87e304b842775497d75b6a6e4acd64eac080c3/_next/static/media/story_badge.4efcb631.png","height":48,"width":165,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVm0e9Yu+5avO8t3uY84OhO2et04e+D1/J60vGVDSr4AAAABXRSTlP+7/b4/GJUYwMAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAaSURBVAiZY2BhY2Nj52BnYmBmZWVlYOBgBAADAwBKXzQjuAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./constants/index.ts + 3 modules
var constants = __webpack_require__(39819);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/date.ts + 31 modules
var date = __webpack_require__(9987);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./components/common/Avatar.tsx
var Avatar = __webpack_require__(81649);
// EXTERNAL MODULE: ./components/common/Badge.tsx
var Badge = __webpack_require__(63732);
// EXTERNAL MODULE: ./components/common/EFinderImage.tsx + 1 modules
var EFinderImage = __webpack_require__(92145);
// EXTERNAL MODULE: ./components/common/Image.tsx
var Image = __webpack_require__(85496);
// EXTERNAL MODULE: ./components/user/Nickname.tsx
var Nickname = __webpack_require__(87682);
;// CONCATENATED MODULE: ./components/stories/Story.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 2px 3px;\n      color: ",
        ";\n      font-size: 10px;\n      background-color: ",
        ";\n      border-radius: 3px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: ",
        "px ",
        "px;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: ",
        "px ",
        "px 0px;\n  cursor: pointer;\n  min-width: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  max-width: calc(100% - 36px);\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    width: 72px;\n    height: 54px;\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    width: 98px;\n    height: 72px;\n    border-radius: ",
        "px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      position: relative;\n      width: 98px;\n      height: 72px;\n      ",
        "\n      border: 1px solid ",
        ";\n      overflow: hidden;\n      flex-shrink: 0;\n\n      .inactive {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        width: 98px;\n        height: 72px;\n        ",
        "\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 1;\n        overflow: hidden;\n        color: ",
        ";\n        ",
        ";\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 72px;\n  margin-left: ",
        "px;\n  overflow: hidden;\n  flex-grow: 1;\n\n  h6 {\n    span + span {\n      margin-left: ",
        "px;\n    }\n  }\n\n  p {\n    margin-top: ",
        "px;\n    font-size: ",
        "px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 56px;\n  overflow: hidden;\n  flex-grow: 1;\n  min-width: 0;\n\n  ",
        " {\n    height: auto;\n    min-height: 72px;\n  }\n\n  h6 {\n    color: ",
        ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .description {\n    margin-top: 2px;\n    ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ",
        " {\n      white-space: normal;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n  }\n  .info {\n    ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-top: 2px;\n  }\n  .tapCount {\n    color: ",
        ";\n    font-weight: 600;\n    line-height: normal;\n  }\n  .nickname {\n    margin-left: ",
        "px;\n    color: ",
        ";\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 11px ",
        "px;\n  width: calc(100vw - 118px);\n  flex-grow: 1;\n  height: 90px;\n\n  .title {\n    color: ",
        ";\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    display: flex;\n    align-items: center;\n    width: calc(100vw - 118px - 52px);\n  }\n\n  .nickname {\n    display: flex;\n    align-items: center;\n    font-size: 11px;\n    margin-top: 4px !important;\n    width: calc(100vw - 118px - 64px);\n    overflow: hidden; /* 추가 */\n    text-overflow: ellipsis; /* 추가 */\n    white-space: nowrap; /* 줄 바꿈 방지 */\n  }\n  .label {\n    margin-right: 3px;\n    height: 15px;\n    span {\n      display: block !important;\n      width: 21px;\n      height: 15px;\n      font-size: 8px;\n      text-align: center;\n    }\n  }\n\n  h6 {\n    display: flex;\n    vertical-align: middle;\n    height: 15px;\n    align-text: center;\n    text-align: center;\n    align-items: center;\n    width: calc(100vw - 118px - 52px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  p {\n    margin-top: 4px;\n    font-size: ",
        "px;\n    color: ",
        ";\n    font-family: 'Apple SD Gothic Neo';\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px; /* 133.333% */\n  }\n\n  .description {\n    margin-top: 4px;\n    font-size: 11px;\n    width: calc(100vw - 118px - 52px);\n    color: ",
        ";\n    font-family: 'Apple SD Gothic Neo';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    max-height: 32px;\n    min-height: 32px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  bottom: 4px;\n  font-size: ",
        "px;\n  color: ",
        ";\n\n  > span {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 2px;\n  font-size: ",
        "px;\n  color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 28px;\n  flex-shrink: 0;\n  margin-left: ",
        "px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 32px;\n  flex-shrink: 0;\n  text-align: center;\n  color: ",
        ";\n  display: flex;\n  algin-items: center;\n  justify-content: center;\n\n  .label {\n    span {\n      display: block !important;\n      width: 23px;\n      height: 16px;\n      font-size: 8px;\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  top: 0;\n  right: 0;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  width: 72px;\n\n  p {\n    margin-top: ",
        "px;\n    font-size: ",
        "px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 5px;\n  padding: 0px 8px;\n  width: 100%;\n  text-overflow: hidden;\n  z-index: 9;\n  color: white;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  z-index: 9;\n  color: white;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  p {\n    font-size: ",
        "px;\n  }\n\n  .badge-container {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 100%;\n    height: 100%;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 120px;\n    height: 90px;\n    border: 1px solid ",
        ";\n    border-radius: 3px 0px 0px 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    width: 75px;\n    height: 56px;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    overflow: hidden;\n    flex-shrink: 0;\n\n    ",
        " {\n      width: 98px;\n      height: 72px;\n    }\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  z-index: 10;\n  opacity: 0.3;\n  background-color: black;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 11;\n  color: white;\n\n  p {\n    margin-top: 3px;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}



















var HIDDEN_STATS_STORY_IDS = [
    9817116,
    9817120,
    9817119,
    9817121
];
var tagCSS = (0,emotion_react_browser_esm.css)(_templateObject());
var customTagCSS = function(type) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject1(), theme.true.white, type === "tap_novel" ? theme.service.violet : type === "waitfree" ? theme.colors.yellow500 : theme.colors.red500);
    };
};
var StoryTag = function(param) {
    var theme = param.theme, saleType = param.saleType, type = param.type, hasHonorPartnership = param.hasHonorPartnership;
    var t = (0,esm/* useTranslation */.$G)().t;
    return hasHonorPartnership ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: tagCSS,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Image/* default */.Z, {
            src: story_badge,
            width: 55,
            height: 16,
            alt: t("명예 작품")
        })
    }) : theme === constants/* StoryTheme.tapNovel */.xb.tapNovel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("tap_novel")
        ],
        children: t("탭소설")
    }) : saleType === constants/* StorySaleType.standardWaitfree */.dn.standardWaitfree ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("waitfree")
        ],
        children: t("기다리면무료")
    }) : type === "original" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: [
            tagCSS,
            customTagCSS("original")
        ],
        children: t("오리지널")
    }) : null;
};
/**
 * Component
 */ var storyCSS = (0,emotion_react_browser_esm.css)(_templateObject2(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var srStoryCSS = (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var rsStoryCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject4(), theme.border.lightest);
};
var _obj;
var CoverImageSize = (_obj = {}, _defineProperty(_obj, dist_esm/* Sizes.small */.u8.small, (0,emotion_react_browser_esm.css)(_templateObject5(), dist_esm/* Radius.xsmall */.wU.xsmall)), _defineProperty(_obj, dist_esm/* Sizes.medium */.u8.medium, (0,emotion_react_browser_esm.css)(_templateObject6(), dist_esm/* Radius.small */.wU.small)), _obj);
var coverImageCSS = function(size) {
    return function(theme) {
        return (0,emotion_react_browser_esm.css)(_templateObject7(), CoverImageSize[size], theme.border.lightest, CoverImageSize[size], theme.var.white, dist_esm/* Typography.body11 */.ZT.body11);
    };
};
var infoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject8(), dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray600);
};
var srInfoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject9(), css/* media.desktop */.BC.desktop, theme.var.black, dist_esm/* Typography.body12 */.ZT.body12, theme.var.gray600, css/* media.desktop */.BC.desktop, dist_esm/* Typography.body12 */.ZT.body12, theme.colors.main500, dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.gray400);
};
var rsInfoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject10(), dist_esm/* Spacing.small */.Ki.small, theme.colors.main500, dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray400, theme.var.gray400);
};
var userCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject11(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray500, dist_esm/* Spacing.xxsmall */.Ki.xxsmall);
};
var tapCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject12(), dist_esm/* FontSizes.xsmall */.TS.xsmall, theme.var.gray500);
};
var rankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject13(), dist_esm/* Spacing.xsmall */.Ki.xsmall, theme.var.black);
};
var srRankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject14(), theme.var.black);
};
var Story = function(_param) {
    var rank = _param.rank, label = _param.label, onClick = _param.onClick, isMyPage = _param.isMyPage, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, _isActive = _param.isActive, isActive = _isActive === void 0 ? true : _isActive, story = _objectWithoutProperties(_param, [
        "rank",
        "label",
        "onClick",
        "isMyPage",
        "isInflow",
        "isActive"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user, tapCount = story.tapCount, hasNewEpisode = story.hasNewEpisode, firstEpisodePublished = story.firstEpisodePublished;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var ref = (0,Badge/* useBadgePresets */.fw)(), yellow = ref.yellow, red = ref.red;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var renderLabels = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
            children: [
                hasNewEpisode && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpread({
                    text: "UP"
                }, yellow)),
                firstEpisodePublished && (0,date/* differenceInDays */.jc)(new Date(), firstEpisodePublished) < 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpread({
                    text: "NEW"
                }, red))
            ]
        });
    }, [
        hasNewEpisode,
        firstEpisodePublished
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: storyCSS,
        "data-id": id,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS(dist_esm/* Sizes.medium */.u8.medium),
                children: [
                    isMyPage && !isActive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: "inactive",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                icon: ic_lock,
                                d: 24
                            }),
                            "비공개"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: rankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                    children: rank
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: infoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h6", {
                        className: "ellipsis align-middle",
                        children: [
                            renderLabels(),
                            label,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis",
                        children: summary
                    }),
                    user ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: userCSS,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Avatar/* default */.ZP, _objectSpread({
                                size: Avatar/* AvatarSize.xsmall */.DZ.xsmall
                            }, user)),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Nickname/* default */.Z, _objectSpread({}, user))
                        ]
                    }) : null,
                    tapCount !== undefined && !HIDDEN_STATS_STORY_IDS.includes(id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        css: tapCSS,
                        className: "icon-text",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* Tap */.Uw,
                                color: theme.var.gray500,
                                size: dist_esm/* Sizes.small */.u8.small
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                children: (0,misc/* simplifyNumber */.Qh)({
                                    value: tapCount !== null && tapCount !== void 0 ? tapCount : 0
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var stories_Story = (Story);
/**
 * Other view types
 */ var storyWrapCSS = (0,emotion_react_browser_esm.css)(_templateObject15());
var storyActionCSS = (0,emotion_react_browser_esm.css)(_templateObject16(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.small */.Ki.small);
var storyCardCSS = (0,emotion_react_browser_esm.css)(_templateObject17(), dist_esm/* Spacing.xxsmall */.Ki.xxsmall, dist_esm/* FontSizes.xsmall */.TS.xsmall);
var StoryCard = function(_param) {
    var onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "onClick",
        "isInflow"
    ]);
    var id = story.id, coverImage = story.coverImage, title = story.title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: storyCardCSS,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: coverImageCSS(dist_esm/* Sizes.small */.u8.small),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* default */.ZP, {
                        image: coverImage,
                        h: 54
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                className: "ellipsis",
                children: title
            })
        ]
    });
};
var rrTitleCSS = (0,emotion_react_browser_esm.css)(_templateObject18());
var rrRankCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject19(), theme.colors.main500);
};
var rrStoryCardCSS = (0,emotion_react_browser_esm.css)(_templateObject20(), dist_esm/* FontSizes.xsmall */.TS.xsmall);
var rrCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject21(), theme.border.lightest);
};
var rsCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject22(), theme.border.lightest);
};
var srCoverImageCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject23(), theme.border.lightest, css/* media.desktop */.BC.desktop);
};
var overalyCSS = (0,emotion_react_browser_esm.css)(_templateObject24());
var moreCSS = (0,emotion_react_browser_esm.css)(_templateObject25());
var RRStoryCard = function(_param) {
    var onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, rank = _param.rank, overlay = _param.overlay, isAd = _param.isAd, badgePreset = _param.badgePreset, story = _objectWithoutProperties(_param, [
        "onClick",
        "isInflow",
        "rank",
        "overlay",
        "isAd",
        "badgePreset"
    ]);
    var id = story.id, coverImage = story.coverImage, title = story.title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("article", {
        css: rrStoryCardCSS,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: rrCoverImageCSS,
            children: [
                rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    css: rrRankCSS,
                    children: rank
                }),
                isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "badge-container",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Badge/* default */.ZP, _objectSpreadProps(_objectSpread({
                        text: t("홍보")
                    }, badgePreset), {
                        className: "rank"
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                    image: coverImage,
                    h: 54,
                    layout: "fill"
                }),
                overlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: moreCSS,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("svg", {
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("circle", {
                                    cx: "16",
                                    cy: "16",
                                    r: "15.5",
                                    stroke: "white"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                    d: "M16.5 10V22",
                                    stroke: "white",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                    d: "M22.5 16L10.5 16",
                                    stroke: "white",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            children: t("더보기")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            css: overalyCSS
                        })
                    ]
                }),
                !isAd && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                !overlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    className: "ellipsis",
                    css: rrTitleCSS,
                    children: title
                })
            ]
        })
    });
};
var RSStoryCard = function(_param) {
    var label = _param.label, onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "label",
        "onClick",
        "isInflow"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user;
    var ellipsisedTitle = (title === null || title === void 0 ? void 0 : title.length) > 22 ? title.slice(0, 22) + "..." : title;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: rsStoryCSS,
        "data-id": id,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: rsCoverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: rsInfoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h6", {
                        className: "ellipsis align-middle",
                        children: [
                            !!label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "label",
                                children: label
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "title",
                                children: ellipsisedTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "description ",
                        children: summary
                    }),
                    !!user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis nickname",
                        children: "by " + user.nickname
                    })
                ]
            })
        ]
    });
};
var SRStoryCard = function(_param) {
    var rank = _param.rank, label = _param.label, onClick = _param.onClick, _isInflow = _param.isInflow, isInflow = _isInflow === void 0 ? true : _isInflow, story = _objectWithoutProperties(_param, [
        "rank",
        "label",
        "onClick",
        "isInflow"
    ]);
    var id = story.id, title = story.title, coverImage = story.coverImage, summary = story.summary, user = story.user, tapCount = story.tapCount;
    var tapNumber = (0,misc/* simplifyNumber */.Qh)({
        value: tapCount !== null && tapCount !== void 0 ? tapCount : 0
    });
    var t = (0,esm/* useTranslation */.$G)().t;
    var inflow = (0,useFirebase/* useFirebase */.f)().inflow;
    var handleClick = function(e) {
        if (isInflow) {
            inflow(id);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("article", {
        css: srStoryCSS,
        "data-id": id,
        onClick: handleClick,
        suppressHydrationWarning: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: srCoverImageCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StoryTag, _objectSpread({}, story)),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EFinderImage/* OptimizeEFinderImage */.yK, {
                        image: coverImage,
                        h: 96
                    })
                ]
            }),
            rank && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: srRankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                    children: rank
                })
            }),
            label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: srRankCSS,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: "label",
                    children: label
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: srInfoCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h6", {
                        className: "ellipsis align-middle title",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: "ellipsis description",
                        children: summary
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
                        className: "info",
                        children: [
                            !!tapCount && !HIDDEN_STATS_STORY_IDS.includes(id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "tapCount",
                                children: t(tapNumber)
                            }),
                            !!user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                className: "ellipsis nickname",
                                children: "by " + user.nickname
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39819);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97033);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var nicknameCSS = function(color) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject1(), color && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), color), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xxxsmall */ .Ki.xxxsmall);
};
var Nickname = function(param) {
    var id = param.id, nickname = param.nickname, hasHonorPartnership = param.hasHonorPartnership, _size = param.size, size = _size === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Sizes.xsmall */ .u8.xsmall : _size;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_3__/* .useUserMarketItemInventory */ .wg)(id), data = ref.data, getDecoration = ref.getDecoration;
    var nicknameDeco = getDecoration(data, _constants__WEBPACK_IMPORTED_MODULE_2__/* .MarketItemType.userNickname */ .q9.userNickname);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                css: nicknameCSS(nicknameDeco === null || nicknameDeco === void 0 ? void 0 : nicknameDeco.object.textColor),
                children: nickname
            }),
            hasHonorPartnership && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_1__/* .Honor */ .Sk,
                size: size
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Nickname);


/***/ })

}]);